import Re, { createContext as M, useContext as Y, useState as Ve, useCallback as A, useLayoutEffect as Te, useEffect as oe, useMemo as Me, useReducer as Ae } from "react";
import Ye from "md5";
import We from "pusher-js";
const Ce = M(() => {
  console.warn("activity monitor context is not ready");
}), it = () => Y(Ce);
var ge, re = { exports: {} }, F = {}, Ee, be, Pe = {};
function ze() {
  return Ee || (Ee = 1, t = Pe, process.env.NODE_ENV !== "production" && (function() {
    var n = Re, o = 60103, p = 60106;
    t.Fragment = 60107;
    var r = 60108, c = 60114, _ = 60109, d = 60110, l = 60112, m = 60113, i = 60120, T = 60115, v = 60116, E = 60121, I = 60122, ae = 60117, ie = 60129, se = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var P = Symbol.for;
      o = P("react.element"), p = P("react.portal"), t.Fragment = P("react.fragment"), r = P("react.strict_mode"), c = P("react.profiler"), _ = P("react.provider"), d = P("react.context"), l = P("react.forward_ref"), m = P("react.suspense"), i = P("react.suspense_list"), T = P("react.memo"), v = P("react.lazy"), E = P("react.block"), I = P("react.server.block"), ae = P("react.fundamental"), P("react.scope"), P("react.opaque.id"), ie = P("react.debug_trace_mode"), P("react.offscreen"), se = P("react.legacy_hidden");
    }
    var ce = typeof Symbol == "function" && Symbol.iterator, V = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      for (var u = arguments.length, s = new Array(u > 1 ? u - 1 : 0), S = 1; S < u; S++) s[S - 1] = arguments[S];
      (function(g, y, h) {
        var b = V.ReactDebugCurrentFrame, O = "";
        if (D) {
          var L = k(D.type), w = D._owner;
          O += (function(a, R, U) {
            var N = "";
            if (R) {
              var z = R.fileName, H = z.replace(Z, "");
              if (/^index\./.test(H)) {
                var x = z.match(Z);
                if (x) {
                  var _e = x[1];
                  _e && (H = _e.replace(Z, "") + "/" + H);
                }
              }
              N = " (at " + H + ":" + R.lineNumber + ")";
            } else U && (N = " (created by " + U + ")");
            return `
    in ` + (a || "Unknown") + N;
          })(L, D._source, w && k(w.type));
        }
        (O += b.getStackAddendum()) !== "" && (y += "%s", h = h.concat([O]));
        var f = h.map(function(a) {
          return "" + a;
        });
        f.unshift("Warning: " + y), Function.prototype.apply.call(console[g], console, f);
      })("error", e, s);
    }
    var Z = /^(.*)[\\\/]/, je = 1;
    function k(e) {
      if (e == null) return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function") return e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case t.Fragment:
          return "Fragment";
        case p:
          return "Portal";
        case c:
          return "Profiler";
        case r:
          return "StrictMode";
        case m:
          return "Suspense";
        case i:
          return "SuspenseList";
      }
      if (typeof e == "object") switch (e.$$typeof) {
        case d:
          return "Context.Consumer";
        case _:
          return "Context.Provider";
        case l:
          return S = e, g = e.render, y = "ForwardRef", h = g.displayName || g.name || "", S.displayName || (h !== "" ? y + "(" + h + ")" : y);
        case T:
          return k(e.type);
        case E:
          return k(e.render);
        case v:
          var u = (s = e)._status === je ? s._result : null;
          if (u) return k(u);
      }
      var s, S, g, y, h;
      return null;
    }
    var le = {};
    V.ReactDebugCurrentFrame;
    var D = null;
    function W(e) {
      D = e;
    }
    var ue, fe, pe = V.ReactCurrentOwner, X = Object.prototype.hasOwnProperty, Ue = { key: !0, ref: !0, __self: !0, __source: !0 };
    function De(e, u, s, S, g) {
      var y, h = {}, b = null, O = null;
      for (y in s !== void 0 && (b = "" + s), (function(f) {
        if (X.call(f, "key")) {
          var a = Object.getOwnPropertyDescriptor(f, "key").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.key !== void 0;
      })(u) && (b = "" + u.key), (function(f) {
        if (X.call(f, "ref")) {
          var a = Object.getOwnPropertyDescriptor(f, "ref").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.ref !== void 0;
      })(u) && (O = u.ref, (function(f) {
        typeof f.ref == "string" && pe.current;
      })(u)), u) X.call(u, y) && !Ue.hasOwnProperty(y) && (h[y] = u[y]);
      if (e && e.defaultProps) {
        var L = e.defaultProps;
        for (y in L) h[y] === void 0 && (h[y] = L[y]);
      }
      if (b || O) {
        var w = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
        b && (function(f, a) {
          var R = function() {
            ue || (ue = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          R.isReactWarning = !0, Object.defineProperty(f, "key", { get: R, configurable: !0 });
        })(h, w), O && (function(f, a) {
          var R = function() {
            fe || (fe = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          R.isReactWarning = !0, Object.defineProperty(f, "ref", { get: R, configurable: !0 });
        })(h, w);
      }
      return (function(f, a, R, U, N, z, H) {
        var x = { $$typeof: o, type: f, key: a, ref: R, props: H, _owner: z, _store: {} };
        return Object.defineProperty(x._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(x, "_self", { configurable: !1, enumerable: !1, writable: !1, value: U }), Object.defineProperty(x, "_source", { configurable: !1, enumerable: !1, writable: !1, value: N }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
      })(e, b, O, g, S, pe.current, h);
    }
    var Q, ee = V.ReactCurrentOwner;
    function $(e) {
      D = e;
    }
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function de() {
      if (ee.current) {
        var e = k(ee.current.type);
        if (e) return `

Check the render method of \`` + e + "`.";
      }
      return "";
    }
    V.ReactDebugCurrentFrame, Q = !1;
    var ye = {};
    function ve(e, u) {
      if (e._store && !e._store.validated && e.key == null) {
        e._store.validated = !0;
        var s = (function(g) {
          var y = de();
          if (!y) {
            var h = typeof g == "string" ? g : g.displayName || g.name;
            h && (y = `

Check the top-level render call using <` + h + ">.");
          }
          return y;
        })(u);
        if (!ye[s]) {
          ye[s] = !0;
          var S = "";
          e && e._owner && e._owner !== ee.current && (S = " It was passed a child from " + k(e._owner.type) + "."), $(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, S), $(null);
        }
      }
    }
    function he(e, u) {
      if (typeof e == "object") {
        if (Array.isArray(e)) for (var s = 0; s < e.length; s++) {
          var S = e[s];
          te(S) && ve(S, u);
        }
        else if (te(e)) e._store && (e._store.validated = !0);
        else if (e) {
          var g = (function(b) {
            if (b === null || typeof b != "object") return null;
            var O = ce && b[ce] || b["@@iterator"];
            return typeof O == "function" ? O : null;
          })(e);
          if (typeof g == "function" && g !== e.entries) for (var y, h = g.call(e); !(y = h.next()).done; ) te(y.value) && ve(y.value, u);
        }
      }
    }
    function $e(e) {
      var u, s = e.type;
      if (s != null && typeof s != "string") {
        if (typeof s == "function") u = s.propTypes;
        else {
          if (typeof s != "object" || s.$$typeof !== l && s.$$typeof !== T) return;
          u = s.propTypes;
        }
        if (u) {
          var S = k(s);
          (function(g, y, h, b, O) {
            var L = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var w in g) if (L(g, w)) {
              var f = void 0;
              try {
                if (typeof g[w] != "function") {
                  var a = Error((b || "React class") + ": " + h + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw a.name = "Invariant Violation", a;
                }
                f = g[w](y, w, b, h, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (R) {
                f = R;
              }
              !f || f instanceof Error || (W(O), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", h, w, typeof f), W(null)), f instanceof Error && !(f.message in le) && (le[f.message] = !0, W(O), C("Failed %s type: %s", h, f.message), W(null));
            }
          })(u, e.props, "prop", S, e);
        } else s.PropTypes === void 0 || Q || (Q = !0, C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k(s) || "Unknown"));
        typeof s.getDefaultProps != "function" || s.getDefaultProps.isReactClassApproved || C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function me(e, u, s, S, g, y) {
      var h = (function(a) {
        return typeof a == "string" || typeof a == "function" || a === t.Fragment || a === c || a === ie || a === r || a === m || a === i || a === se || typeof a == "object" && a !== null && (a.$$typeof === v || a.$$typeof === T || a.$$typeof === _ || a.$$typeof === d || a.$$typeof === l || a.$$typeof === ae || a.$$typeof === E || a[0] === I);
      })(e);
      if (!h) {
        var b, O = "";
        (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), O += de(), e === null ? b = "null" : Array.isArray(e) ? b = "array" : e !== void 0 && e.$$typeof === o ? (b = "<" + (k(e.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : b = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", b, O);
      }
      var L = De(e, u, s, g, y);
      if (L == null) return L;
      if (h) {
        var w = u.children;
        if (w !== void 0) if (S) if (Array.isArray(w)) {
          for (var f = 0; f < w.length; f++) he(w[f], e);
          Object.freeze && Object.freeze(w);
        } else C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else he(w, e);
      }
      return e === t.Fragment ? (function(a) {
        for (var R = Object.keys(a.props), U = 0; U < R.length; U++) {
          var N = R[U];
          if (N !== "children" && N !== "key") {
            $(a), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), $(null);
            break;
          }
        }
        a.ref !== null && ($(a), C("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
      })(L) : $e(L), L;
    }
    var He = function(e, u, s) {
      return me(e, u, s, !1);
    }, Fe = function(e, u, s) {
      return me(e, u, s, !0);
    };
    t.jsx = He, t.jsxs = Fe;
  })()), Pe;
  var t;
}
var J = (be || (be = 1, process.env.NODE_ENV === "production" ? re.exports = (function() {
  if (ge) return F;
  ge = 1;
  var t = Re, n = 60103;
  if (F.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var o = Symbol.for;
    n = o("react.element"), F.Fragment = o("react.fragment");
  }
  var p = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = Object.prototype.hasOwnProperty, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(d, l, m) {
    var i, T = {}, v = null, E = null;
    for (i in m !== void 0 && (v = "" + m), l.key !== void 0 && (v = "" + l.key), l.ref !== void 0 && (E = l.ref), l) r.call(l, i) && !c.hasOwnProperty(i) && (T[i] = l[i]);
    if (d && d.defaultProps) for (i in l = d.defaultProps) T[i] === void 0 && (T[i] = l[i]);
    return { $$typeof: n, type: d, key: v, ref: E, props: T, _owner: p.current };
  }
  return F.jsx = _, F.jsxs = _, F;
})() : re.exports = ze()), re.exports);
const Le = M(void 0), st = () => Y(Le), Ie = ({ key: t, defaultValue: n, onExternalUpdate: o }) => {
  const [p, r] = Ve(), c = A(() => {
    if (t) try {
      const m = window.localStorage.getItem(t);
      if (!m) return void r(n);
      const i = JSON.parse(m);
      return r(i), i;
    } catch (m) {
      return void console.error(`Error reading local storage item ${t}:`, m);
    }
  }, [n, t]), _ = A((m) => {
    if (t) try {
      const i = JSON.stringify(m);
      window.localStorage.setItem(t, i), r(m), window.dispatchEvent(new StorageEvent("local-storage", { key: t, newValue: i }));
    } catch (i) {
      console.error(`Error setting local storage item ${t}:`, i);
    }
  }, [t]), d = A(() => {
    t && (window.localStorage.removeItem(t), new StorageEvent("local-storage", { key: t, url: window.location.origin }));
  }, [t]), l = A((m) => {
    o && m.key === t && (console.log(JSON.stringify(m, null, 2)), o(c()));
  }, [t, c, o]);
  return Te(() => {
    c();
  }, [c]), oe(() => (window.addEventListener("local-storage", l), window.addEventListener("storage", l), () => {
    window.removeEventListener("local-storage", l), window.removeEventListener("storage", l);
  }), [l]), [p, _, d];
}, G = (t, n) => {
  let o, p = t;
  try {
    let r = n.split(".");
    for (r.length === 0 && (r = [n]); r.length > 0; ) {
      if (o = r.shift(), !o) return;
      if (Array.isArray(p[o])) {
        p = [];
        const c = r.splice(-1).join(".");
        for (let _ = 0, d = t[o].length; _ < d; _++) p.push(G(t[o][_], c));
      } else p = p[o];
    }
    return p;
  } catch (r) {
    return void console.error("unexpected error occurred while trying to find value from pointer", t, n, r);
  }
}, q = (t, n, o) => {
  let p, r = -1;
  for (let c = 0, _ = t?.length; c < _; c += 1) if (p = G(t[c], n), Array.isArray(p)) {
    if (p.indexOf(o) !== -1) {
      r = c;
      break;
    }
  } else if (p === o) {
    r = c;
    break;
  }
  return r;
}, we = (t, n) => [...t].sort((o, p) => {
  let r = G(o, n.toString()), c = G(p, n.toString());
  return typeof r == "string" && (r = r.toLocaleLowerCase()), typeof c == "string" && (c = c.toLocaleLowerCase()), r === c ? 0 : r < c ? -1 : 1;
}), ct = ({ partitionKey: t, activityKinds: n, children: o }) => {
  const p = Me(() => n.reduce((d, l) => (d[l.kind] = [], d), { all: [] }), [n]), [r, c] = Ie({ key: t, defaultValue: p }), _ = A((d) => {
    if (!r) return void console.warn("unable to add activity: monitor not initialized");
    const l = d.kind;
    if (!(l in r)) return void console.warn(`unable to add activity: unsupported kind: ${d.kind}`, d);
    if (!d.entity.id) return void console.warn("unable to add activity: entity does not have an ID", d);
    const m = (/* @__PURE__ */ new Date()).toJSON();
    let i, T;
    switch (l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        i = r[l], T = { ...d, visited_at: m };
    }
    const v = q(r[d.kind], "entity.id", d.entity.id);
    if (v === -1) i.unshift(T), i.length = Math.min(i.length, 10);
    else switch (i[v].visited_at = m, we(i, "visited_at"), l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        r[l] = i.reverse();
    }
    const E = q(r.all, "entity.id", d.entity.id);
    E === -1 ? (r.all.unshift(T), r.all.length = Math.min(r.all.length, 10)) : (r.all[E].visited_at = m, we(r.all, "visited_at"), r.all = r.all.reverse()), c(r);
  }, [r, c]);
  return J.jsx(Le.Provider, { value: r, children: J.jsx(Ce.Provider, { value: _, children: o }) });
}, lt = { ALL: "all", PROJECT: "project", SCENARIO_INTERACTIVE: "scenario-interactive", SCENARIO_RULE: "scenario-rule" }, ne = () => {
  console.warn("auth context is not ready");
}, Be = M({ isLoading: !0, isAuthenticated: !1, provider: "auth0", availableProviders: ["auth0"], accessToken: void 0, getAccessToken: () => Promise.reject(ne()), login: () => Promise.reject(ne()), logout: ne }), ut = () => Y(Be), Ke = "PUSHER_SET_CONTROLLER", Je = (t, n) => ({ ...t, _controller: n }), Ge = "PUSHER_SET_USER_CHANNEL", qe = (t, n) => ({ ...t, userChannel: n }), Ze = (t, n) => {
  switch (n.type) {
    case Ke:
      return Je(t, n.data);
    case Ge:
      return qe(t, n.data);
  }
}, B = () => {
  console.warn("pusher context is not ready");
}, ke = { _controller: void 0, userChannel: void 0, initPusher: B, subscribeToPush: B, unsubscribeFromPush: B, shutdownPusher: B }, Ne = M(ke), ft = () => Y(Ne), pt = ({ children: t }) => {
  const n = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "", OTEL_COLLECTOR_URL: "https://platform.hivery.ai/collect", OTEL_SERVICE_NAME: "", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" }, [o, p] = Ae(Ze, { ...ke }), r = A((v) => {
    c({ type: "PUSHER_SET_CONTROLLER", data: v });
  }, [c = p]);
  var c;
  const _ = ((v) => A((E) => {
    v({ type: "PUSHER_SET_USER_CHANNEL", data: E });
  }, [v]))(p), d = A((v, E) => {
    const I = new We(n.PUSHER_APP_KEY, { authEndpoint: `${n.CURATE_API_V1}/pusher/authenticate`, auth: { headers: { Authorization: `Bearer ${v}` } }, cluster: n.PUSHER_CLUSTER, forceTLS: !0 });
    r(I), _(I.subscribe(`private-user-${Ye(E)}`));
  }, [n.CURATE_API_V1, n.PUSHER_APP_KEY, n.PUSHER_CLUSTER, r, _]), l = A((v) => {
    if (!o._controller) return void console.warn("unable to subscribe to notifications: service not ready.");
    const E = o._controller.allChannels();
    if (!E) return o._controller.subscribe(v);
    const I = q(E, "name", v);
    return I === -1 ? o._controller.subscribe(v) : E[I];
  }, [o._controller]), m = A((v) => {
    if (!o._controller) return void console.warn("unable to unsubscribe to notifications: service not ready.");
    const E = o._controller.allChannels();
    E && (q(E, "name", v) !== -1 ? o._controller.unsubscribe(v) : console.warn("unable to unsubscribe: channel was not found", v));
  }, [o._controller]), i = A(() => {
    if (!o._controller) return void console.warn("unable to shutdown notifications: service not ready.");
    const v = o._controller, E = o._controller.allChannels();
    E && E.forEach((I) => {
      v.unsubscribe(I.name);
    });
  }, [o._controller]), T = { ...o, initPusher: d, subscribeToPush: l, unsubscribeFromPush: m, shutdownPusher: i };
  return J.jsx(Ne.Provider, { value: T, children: t });
}, Xe = "THEME_SET_MODE", Qe = (t, n) => ({ ...t, mode: n }), et = (t, n) => {
  if (n.type === Xe) return Qe(t, n.data);
}, K = { mode: "light", setMode: () => {
  console.warn("theme context is not ready");
} }, xe = M(K), dt = () => Y(xe), yt = ({ children: t, disabled: n = !0 }) => {
  const [o, p] = Ae(et, { ...K, mode: K.mode }), r = A((i) => {
    c({ type: "THEME_SET_MODE", data: i });
  }, [c = p]);
  var c;
  const [_, d] = Ie({ key: "themeMode", defaultValue: K.mode, onExternalUpdate: r }), l = A((i) => {
    document.body.dataset.theme = i, d(i), r(i);
  }, [r, d]), m = { ...o, setMode: l };
  return oe(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    _ !== o.mode && (document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = _, r(_));
  }, [n, r, _, o.mode]), Te(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = o.mode;
  }, [n, o.mode]), J.jsx(xe.Provider, { value: m, children: t });
}, j = [], vt = (t) => {
  const n = t.navigate.bind(t);
  t.navigate = async (...o) => {
    const p = o;
    if (j.length > 0) {
      const r = j.map((c) => c());
      if (!(await Promise.all(r)).every(Boolean)) return;
    }
    return n(...p);
  }, t.subscribe(async (o) => {
    if (o.historyAction === "POP" && j.length > 0) {
      const p = j.map((r) => r());
      (await Promise.all(p)).every(Boolean) || n(1);
    }
  });
}, Se = (t) => {
  t.preventDefault(), t.returnValue = "";
}, Oe = (t) => {
  t.preventDefault(), t.stopImmediatePropagation(), t.stopPropagation();
}, tt = (t) => (j.length === 0 && (addEventListener("beforeunload", Se, { capture: !0 }), addEventListener("popstate", Oe, { capture: !0 })), j.push(t), () => {
  const n = j.indexOf(t);
  j.splice(n, 1), j.length === 0 && (removeEventListener("beforeunload", Se, { capture: !0 }), removeEventListener("popstate", Oe, { capture: !0 }));
}), rt = (t, n) => {
  oe(() => {
    if (t) return tt(n);
  }, [n, t]);
}, ht = (t, n = !1) => {
  rt(n, A(() => confirm(t), [t]));
};
export {
  lt as ACTIVITY_KINDS,
  ct as ActivityMonitorProvider,
  Be as AuthContext,
  Ne as PusherContext,
  pt as PusherProvider,
  yt as ThemeProvider,
  tt as blockNavigation,
  vt as createRouterObservers,
  it as useActivityMonitorActions,
  st as useActivityMonitorState,
  ut as useAuthContext,
  rt as useBlocker,
  Ie as useLocalStorage,
  ht as usePrompt,
  ft as usePusherContext,
  dt as useThemeContext
};
//# sourceMappingURL=mystique.js.map
